<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row justify="center" no-gutters>
          <v-btn
            v-for="city in WeatherData.cities"
            :key="city"
            :value="city.tag"
            variant="text"
            rounded="0"
            :href="'/usa/' + city.tag + '/'"
          >
          {{ city.name }}
          </v-btn>
        </v-row>
      </v-container>

      <v-container>
        <v-card variant="tonal" color="blue-darken-1">
          <div class="text-h5 pa-2 d-flex justify-center">[アメリカ] {{ cityName }}の年間の天気</div>
        </v-card>
      </v-container>

      <v-container>
        <v-card>
          <chartTemp :monthlyData="monthlyData" ></chartTemp>
        </v-card>
      </v-container>
      <v-container>
        <v-card>
          <chartRain :monthlyData="monthlyData" ></chartRain>
        </v-card>
      </v-container>
      <v-container>
        <v-card>
          <WeatherTable :monthlyData="monthlyData" />
        </v-card>
      </v-container>

      <v-container>
        <v-card variant="flat">
          <v-card-text class="pt-0">
            上記のデータは、<a href="https://www.weather.gov/" target="_blank">National Weather Service[アメリカ国立気象局]<v-icon icon="$openNew" class="mx-1" size="x-small" /></a>が公表している過去5年間(2020-2024年)の気象データから平均値を算出したものです。
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import WeatherChartTemp from "../components/WeatherChartTemp";
import WeatherChartRain from "../components/WeatherChartRain";
import WeatherTable from "../components/WeatherTable";
import WeatherData from '../assets/WeatherDataUS.json'
import { ref } from 'vue'

var monthlyData = []
var cityName = ref('')

export default {
  name: "app",
  props: [ 'city', 'cityJP' ],
  components: {
    chartTemp: WeatherChartTemp,
    chartRain: WeatherChartRain,
    WeatherTable
  },
  data() {
    if (Object.keys(this.$route.params).length === 0) {
      monthlyData = WeatherData.cities[0].monthlyData
      cityName.value = WeatherData.cities[0].name
    } else {
      for (var i = 0; i < Object.keys(WeatherData.cities).length; i++) {
        if (WeatherData.cities[i].tag == this.city) {
          monthlyData = WeatherData.cities[i].monthlyData
          cityName.value = WeatherData.cities[i].name
        }
      }
    }
    return {
      WeatherData,
      monthlyData,
      cityName
    }
  },
  methods: {
    handler() {
      var args = arguments;
      for (var arg of args) {
        if (arg instanceof Function) {
          arg();
        }
      }
    },
  },
  watch: {
    $route(to) {
      // react to route changes...
      if (to.params !== '') {
        for (var i = 0; i < Object.keys(WeatherData.cities).length; i++) {
          if (WeatherData.cities[i].tag == to.params.city) {
            this.monthlyData = WeatherData.cities[i].monthlyData
            cityName.value = WeatherData.cities[i].name
          }
        }
      }
    }
  }
};
</script>
